import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { loginPath } from '~/common/define/path'
import { lineToBreak } from '~/common/utils/string'
import MainTitle from '~/components/atoms/title/MainTitle'
import SupplementText from '~/components/atoms/text/SupplementText'
import SignupProgress, { SignupProgressStatus } from '~/components/app/modules/signup/SignupProgress'
import MainContent, { MainContentType } from '~/components/wrapper/section/MainContent'
import FormInputNote from '~/components/wrapper/form/FormInputNote'
import DescriptionText from '~/components/wrapper/text/DescriptionText'
import SupportButton from '~/components/atoms/button/SupportButton'
import Line from '~/components/atoms/line/Line'
import SignupForm from '~/components/app/form/signup/SignupForm'
import Segments from '~/components/wrapper/section/Segments'
import Section, { SectionType } from '~/components/wrapper/section/Section'

const SignupPage = () => {
  const { t } = useTranslation()
  const [completed, setCompleted] = useState<boolean>(false)

  return (
    <MainContent type={MainContentType.CENTER}>
      <Section type={SectionType.WIDE}>
        <MainTitle>
          {t('signup:title')}
        </MainTitle>
        <SignupProgress status={SignupProgressStatus.FORM}/>
        {completed ?
          <Segments column center>
            <DescriptionText>{lineToBreak(t('signup:completed'))}</DescriptionText>
            <SupportButton link={'/'}>
              {t('action.redo_top')}
            </SupportButton>
          </Segments> :
          <>
            <SignupForm completed={() => setCompleted(true)}/>
            <Line/>
            <SupportButton link={loginPath()}>
              {t('action.to_login')}
            </SupportButton>
            <FormInputNote>
              <SupplementText weak>
                {t('signup:guidance')}
              </SupplementText>
            </FormInputNote>
          </>
        }
      </Section>
    </MainContent>
  )
}

export default SignupPage